import { ReactElement, ReactNode, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { hooks as commonHooks } from '@sitebuilder/common';
import { widgetsSvg } from '../../assets/images';
import { StateShape as ReduxStateShape } from '../../reducers';
import { actionCreators } from '../../reducers/slidedecks';
import SaveSlidedeckForm from '../../TemplateEditor/SaveSlidedeckForm';
import { VersionsAccordionGroup } from '../BaseComponents';
import AddNewFolderForm from './AddNewFolderForm';

interface SlidedecksRightSidebarProps {
    addNewSlidedeck: boolean;
    urlState: string;
    addNewFolder: boolean;
}

const SlidecksRightSidebar = (props: SlidedecksRightSidebarProps): ReactElement & ReactNode => {
    const { addNewSlidedeck, urlState, addNewFolder } = props;
    const [accordionActiveKey, setAccordionActiveKey] = useState('');
    const {
        slidedecks,
        selectedSlidedecks,
        slidedeckVersions,
        slidedeckVersionsLoading,
        revertedVersion,
    } = useSelector((state: ReduxStateShape) => state.slidedecks);
    const dispatch = useDispatch();

    const i18n = commonHooks.useLocalization();

    const onClickAccordion = (eventKey: string) => {
        if (eventKey === '1' && selectedSlidedecks.length === 1) {
            dispatch(actionCreators.loadSlidedecksVersions('public', selectedSlidedecks[0]));
        }

        if (eventKey && eventKey !== accordionActiveKey) {
            setAccordionActiveKey(eventKey);
        } else {
            setAccordionActiveKey('');
        }
    };

    const onClickRestoreVersion = (eventKey: string) => {
        dispatch(
            actionCreators.revertSlidedecksVersions('public', selectedSlidedecks[0], eventKey)
        );
    };

    useEffect(() => {
        setAccordionActiveKey('0');

        if (revertedVersion && selectedSlidedecks.length === 1) {
            dispatch(actionCreators.loadSlidedecksVersions('public', selectedSlidedecks[0]));
        }
    }, [dispatch, selectedSlidedecks, revertedVersion]);

    return (
        <>
            {(selectedSlidedecks || addNewSlidedeck || addNewFolder) && (
                <div className="slidedecks-side-bar-header">
                    <img className={'slidedecks-icon'} src={widgetsSvg} alt="slidedecks-icon" />
                    <span className={'slidedecks-title'}>{i18n.t('slidedecks_title')}</span>
                </div>
            )}
            {selectedSlidedecks.length > 0 && (
                <VersionsAccordionGroup
                    selectedItems={selectedSlidedecks}
                    onClickAccordion={onClickAccordion}
                    onClickRestoreVersion={onClickRestoreVersion}
                    items={slidedecks}
                    itemVersions={slidedeckVersions}
                    accordionActiveKey={accordionActiveKey}
                    itemVersionsLoading={slidedeckVersionsLoading}
                    type={'slidedecks'}
                    urlState={urlState}
                />
            )}
            {addNewSlidedeck && (
                <SaveSlidedeckForm
                    addNewSlidedeck
                    formTitle="Create New Slidedeck"
                    defaultActiveAccordionKey="0"
                    urlState={urlState}
                />
            )}

            {addNewFolder && <AddNewFolderForm urlState={urlState} />}
        </>
    );
};
export default SlidecksRightSidebar;
